// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__dyy0I","content":"Logo_content__2RzX1","logo":"Logo_logo__2b7Bk"};